import { SearchResultType } from '../hooks/useGlobalSearchResults/useGlobalSearchResults.types';

export const prepareInitialSearchLimitObject = (initialResultLimit: number) => {
  const initialValue: Record<SearchResultType, number> = {} as Record<SearchResultType, number>;
  for (const searchResultType of Object.keys(SearchResultType) as unknown as SearchResultType[]) {
    initialValue[searchResultType] = initialResultLimit;
  }
  return initialValue;
};
